import React from "react";
import ProViewField from '../../components/common/ProViewField';
import { Allergy, Medication } from "../../constants/ProIcons";

const ProClientDetails = ({clientData})=>{
    return <div>
                <div className="p-field p-grid view-form">
                     { clientData.occupantType === 'CLIENT' && 
                      <label className="p-col-fixed" style={{ fontWeight: 'bold' }}>{clientData.clientName} ({clientData.clientId})</label>
                     }
                    { clientData.occupantType !== 'CLIENT' && 
                      <label className="p-col-fixed" style={{ fontWeight: 'bold' }}>
                         {clientData.dependentName} 
                          </label>
                     }
                </div>
                { clientData.occupantType === 'CLIENT' && 
                    <div style={{width:'100%', padding:'0px', textAlign: 'left'}} className="p-field p-grid view-form">
                        <div style={{width:'75%', padding:'0px'}} className="p-col-fixed">
                            <ProViewField labelText="Sex" value={clientData.sex} width="150px"></ProViewField>
                            <ProViewField labelText="DOB" value={clientData.dateOfBirth}  width="150px"></ProViewField>
                            <ProViewField labelText="Age" value={clientData.age}  width="150px"></ProViewField>
                            <ProViewField labelText="Primary Staff" value={clientData.primaryStaffName}  width="150px"></ProViewField>
                            <ProViewField labelText="Primary Program" value={clientData.primaryProgramName}  width="150px"></ProViewField>
                            <ProViewField labelText="Age Range Category" value={clientData.ageRangeCategory}  width="150px"></ProViewField>
                        </div>
                        <div className="p-col" style={{textAlign: 'center'}} >
                        <i className="fad fa-user-alt" style={{ fontSize: 84 }}></i>
                        <div style={{clear:'both', height:'3px'}}></div>
                        { clientData.occupantType === 'CLIENT' && clientData.hasClientMedications && 
                            <i className ="fas" aria-hidden="true" style={{ color: 'red', fontSize: 14, marginLeft:'5px' }}>
                                <Medication/>
                            </i>
                        }
                        { clientData.occupantType === 'CLIENT' && clientData.hasClientAllergy && 
                            <i className ="fas" aria-hidden="true" style={{ color: 'green', fontSize: 14,}}>
                                <Allergy/>
                            </i>
                        }                        
                        </div>
                    </div>
                }
               { clientData.occupantType !== 'CLIENT' && 
                    <div style={{width:'100%'}}>
                        <ProViewField labelText="Dependent of" value={clientData.clientName + ' (#'+clientData.clientId+')'}  width="150px"></ProViewField>
                    </div>
                }
                <div style={{width:'100%'}}>
                    <ProViewField labelText="Start Date" value={clientData.startDate}  width="150px"></ProViewField>
                    <ProViewField labelText="End Date"value={clientData.endDate}  width="150px"></ProViewField>
                    <ProViewField labelText="Length of Stay" value={clientData.lengthOfStay}  width="150px"></ProViewField>
                </div>
                { clientData.occupantType === 'CLIENT' && 
                    <div style={{width:'100%'}}>
                        <ProViewField labelText="Anticipated Payer" value={clientData.anticipatedPayer}  width="150px"></ProViewField>                       
                    </div>
                }
        </div>

}

export default ProClientDetails;

